import FilePreview from './file-preview';

export * from './types';

export default FilePreview;
